<template>
   <div>
        <template v-if="groupsSorted.length">
            <SingleEventMarketGroup
                v-for="group in groupsSorted"
                :group="group"
                :key="`${group.marketId}|${group.specHash}`"
                :matchId="matchId"
            />
        </template>
        <div
            class="single-noodds"
            v-else
        >
            <img
                src="../../../../assets/img/error-no-odds.svg"
            >
            <p>{{$t('NOODDSAVAILABLEATTHISMOMENT')}}</p>
        </div>
    </div>
</template>

<script>
import
{
    mapActions,
    mapGetters,
}
from 'vuex';
import SingleEventMarketGroup from './MarketGroup.vue';

export default
{
    name: 'MarketGroupContainer',
    props: [
        'matchId',
        'marketGroups',
        'extendedMarketGroups',
        'selectedGroup',
    ],
    components:
    {
        SingleEventMarketGroup,
    },
    methods:
    {
        ...mapActions([]),
    },
    computed:
    {
        ...mapGetters([
            'sportTree',
            'matchesIn',
            'globals',
        ]),
        groups()
        {
            if (this.selectedGroup === 'odds')
            {
                return this.marketGroups;
            }

            if (this.extendedMarketGroups[this.selectedGroup])
            {
                return this.extendedMarketGroups[this.selectedGroup].groups;
            }

            return {};
        },
        groupsSorted()
        {
            const groupsFin = [];

            for (const marketId in this.groups)
            {
                if (this.groups[marketId] !== undefined)
                {
                    for (const specHash in this.groups[marketId])
                    {
                        if (this.groups[marketId][specHash] !== undefined)
                        {
                            const group = this.groups[marketId][specHash];

                            const outcomes = [];
                            for (const outcomeId in group.outcomes)
                            {
                                if (group.outcomes[outcomeId] !== undefined)
                                {
                                    outcomes.push(group.outcomes[outcomeId]);
                                }
                            }

                            group.outcomes = outcomes;
                            group.marketId = marketId;

                            if (outcomes.length
                            && outcomes[0])
                            {
                                group.lineIndex = outcomes[0].lineIndex;
                            }
                            else
                            {
                                group.lineIndex = null;
                            }

                            groupsFin.push(group);
                        }
                    }
                }
            }
            groupsFin.stableSort((a, b) =>
            {
                if (a.orderNum < b.orderNum)
                {
                    return -1;
                }

                if (a.orderNum > b.orderNum)
                {
                    return 1;
                }

                if (a.lineIndex != null
                && b.lineIndex != null
                && a.marketId === b.marketId)
                {
                    if (a.lineIndex < b.lineIndex)
                    {
                        return -1;
                    }

                    if (a.lineIndex > b.lineIndex)
                    {
                        return 1;
                    }
                }

                return 0;
            });

            const groupNamesDisplayed = {};

            for (const group of groupsFin)
            {
                if (!groupNamesDisplayed[group.marketId])
                {
                    group.canShowMarketName = true;
                    groupNamesDisplayed[group.marketId] = true;
                }
            }

            return groupsFin;
        },
    },
};
</script>
